module.exports = __webpack_public_path__ + "img/2022-12-14_13-01-08.1ae6f4ac.jpg";